import { CommonModule } from '@angular/common';
import { Component, signal } from '@angular/core';

const DURACAO_TOAST_MS = 30000;

@Component({
  selector: 'app-toast',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './toast.component.html',
  styleUrl: './toast.component.scss',
})
export class ToastComponent {
  readonly show = signal(false);
  readonly message = signal('');
  readonly typeClass = signal('toast-info');

  showToast(message: string, type: string = 'success'): void {
    this.message.set(message);
    this.typeClass.set(`toast-${type}`);
    this.show.set(true);
    this.scrollToTop();

    setTimeout(() => {
      this.hideToast();
    }, DURACAO_TOAST_MS);
  }

  hideToast(): void {
    this.show.set(false);
  }

  // ponytail: app roda embutido em iframe (@iframe-resizer/child, ver app.component.ts) sem
  // scroll próprio — position:fixed do toast fica preso ao topo do documento do iframe, não da
  // janela. scrollToOffset traz esse ponto pra viewport visível; window.scrollTo cobre o caso
  // sem parentIFrame (dev local / outro host).
  private scrollToTop(): void {
    if (window.parentIFrame) {
      window.parentIFrame.scrollToOffset(0, 0);
      return;
    }

    window.scrollTo({ top: 0 });
  }
}
